import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  targetPath: "",
  isViewedUnpaidOrder: false,
};

export const redirectSlice = createSlice({
  name: "redirect",
  initialState,
  reducers: {
    setTargetPath: (state, action) => {
      state.targetPath = action.payload;
    },
    setIsViewedUnpaidOrder: (state, action) => {
      state.isViewedUnpaidOrder = action.payload;
    },
  },
});

export const { setTargetPath, setIsViewedUnpaidOrder } = redirectSlice.actions;

export default redirectSlice.reducer;
